/* unplugin-vue-components disabled */import script from "./FeedbackFormItem.vue?vue&type=script&lang=tsx&setup=true"
export * from "./FeedbackFormItem.vue?vue&type=script&lang=tsx&setup=true"

import "./FeedbackFormItem.vue?vue&type=style&index=0&id=b907b57e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b907b57e"]])

export default __exports__